import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getBanks = ({ churchId }) => {
  return axios.get(`/churches/${churchId}/banks`);
};

export const useBanks = ({ churchId, config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["banks", churchId],
    queryFn: () => getBanks({ churchId })
  });
};
